export default [
    {
        path: '/preferences',
        name: 'preferences',
        meta: { layout: 'dashboard' },
        component: () => import('VIEWS/Catalogs/Preferences.vue')
    }
]
